import TransferRow from './TransferRow';

export default TransferRow;
